import { tvpil } from '../compat/tvpil';
import { queryClient } from '../queryClient';
import { queryKeys } from '../queryKeys';

import { fetchChannelAssets, fetchChannelCollection, fetchEntitledChannels } from './queryFunctions';
import { shouldIncludeAdult } from './utils';

export function getChannelAssetsQueryData() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchChannelAssets>>>(queryKeys.channelAssets);
}

export function getEntitledChannelsQueryData() {
  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchEntitledChannels>>>(queryKeys.entitledChannels);
}

export function getChannelCollectionQueryData(referenceId: string) {
  const category = tvpil.categoryTreeItemsMap.get(referenceId);

  if (!category) {
    return undefined;
  }

  return queryClient.getQueryData<Awaited<ReturnType<typeof fetchChannelCollection>>>(
    queryKeys.channelCollection(category.channels[0], shouldIncludeAdult(category), category.aggregatedKSQL),
  );
}
